import { InjectionToken } from '@angular/core';

export const PR_CONFIG = new InjectionToken('mydocma-pr-config');

export interface PrConfig {
  origin: string;
  clientId: string;
  apiUrl: string;
  production: boolean;
  buildTarget?: string;
  appName: string;
  appIconColor: string;
  mydocmaConfig: {
    apiUrl: string;
    clientUrl: string;
    appId: string;
  };
  authConfig: {
    clientId: string;
    scope: string;
    oidc: boolean;
    issuer: string;
    redirectUri: string;
    requireHttps: boolean;
    responseType: string;
    ignoredUrls: Array<string>;
    logoutUrl: string;
    postLogoutRedirectUri: string;
  };
  prConfig: {
    apiUrl: string;
  };
  webSocketConfig: {
    serverUrl: string;
    reconnectInterval: number;
    reconnectAttempts: number;
    heartbeatInterval: number;
  };
  taskConfig: {
    apiUrl: string;
  };
  appContainerConfig: {
    showBackdropOnCustomerChange: boolean;
  };
}
